import { Controller } from "stimulus";

export default class extends Controller {
  toggleFaq(event) {
    const question = event.currentTarget;
    const icon = question.firstElementChild;
    const answer = question.parentNode.nextElementSibling;

    if (answer.classList.contains("tw-hidden")) {
      this._showFaqAnswer(icon, answer);
    } else {
      this._hideFaqAnswer(icon, answer);
    }
  }

  _showFaqAnswer(icon, answer) {
    answer.classList.remove("tw-hidden");
    icon.classList.remove("fa-plus");
    icon.classList.add("fa-minus");
  }

  _hideFaqAnswer(icon, answer) {
    answer.classList.add("tw-hidden");
    icon.classList.add("fa-plus");
    icon.classList.remove("fa-minus");
  }
}
